import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3da75c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content d-flex flex-column flex-column-fluid pt-0",
  id: "kt_content"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-fluid px-0"
}
const _hoisted_3 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_4 = { class: "flex-column flex-lg-row-auto w-100 w-lg-400px w-xl-450px" }
const _hoisted_5 = { class: "card card-one me-lg-5 mb-5 mb-lg-0" }
const _hoisted_6 = { class: "card-header px-5 py-4 position-sticky bg-white top-0 z-index-1" }
const _hoisted_7 = { class: "d-flex flex-stack w-100" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  class: "w-100 position-relative",
  autocomplete: "off"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-3 translate-middle-y" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-sync fs-1 text-primary" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "fw-bolder text-gray-900 text-hover-primary mb-2 pt-3",
  role: "button",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-target": `#vz-filter-data-roleFilters`
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-filter fs-1" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "position-absolute top-5 start-90 translate-middle badge badge-circle badge-cyan"
}
const _hoisted_19 = {
  class: "card-body py-5 px-0",
  id: "kt_chat_contacts_body"
}
const _hoisted_20 = { class: "d-flex flex-stack p-5 pt-0" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "form-check me-2" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = { class: "ms-1" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "d-flex flex-column align-items-end ms-2" }
const _hoisted_27 = {
  key: 0,
  class: "btn btn-outline btn-outline-primary btn-active-light-primary",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#createGroup",
  "aria-expanded": "false",
  "aria-controls": "createGroup"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed d-none" }, null, -1))
const _hoisted_29 = {
  class: "collapse border border-gray-300",
  id: "createGroup"
}
const _hoisted_30 = { class: "card card-body ms-3 p-4 mt-2 no-border" }
const _hoisted_31 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ms-1 form-label required" }, "Name", -1))
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ms-1 form-label required" }, "Name", -1))
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "modal-footer d-flex justify-content-between p-0 pt-3 border-top-0" }
const _hoisted_40 = {
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
  type: "submit"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed d-none" }, null, -1))
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "d-flex align-items-center" }
const _hoisted_44 = { class: "form-check ms-2" }
const _hoisted_45 = ["value", "disabled"]
const _hoisted_46 = { class: "ms-5" }
const _hoisted_47 = {
  "data-bs-target": "#vz_permissions",
  role: "button",
  "aria-controls": "vz_permissions",
  class: "fw-bolder text-gray-900 text-hover-primary mb-2"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "p-2",
  title: "This role is locked."
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-icon btn-dark btn-circle btn-sm",
  style: {"font-size":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "badge badge-cyan" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-user text-white fs-6" }, null, -1))
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v fs-6" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "d-flex justify-content-between px-5 pt-3 card-footer position-sticky bg-white bottom-0" }
const _hoisted_59 = ["value"]
const _hoisted_60 = {
  key: 0,
  class: "flex-lg-row-fluid",
  id: "vz_permissions"
}
const _hoisted_61 = {
  class: "card card-one",
  id: "kt_chat_messenger"
}
const _hoisted_62 = {
  class: "card-header px-5",
  id: "kt_chat_messenger_header"
}
const _hoisted_63 = { class: "card-title" }
const _hoisted_64 = { class: "d-flex justify-content-center flex-column mx-2" }
const _hoisted_65 = { class: "fs-3" }
const _hoisted_66 = { class: "card-toolbar" }
const _hoisted_67 = { class: "me-1" }
const _hoisted_68 = { class: "search-form" }
const _hoisted_69 = { class: "w-100 position-relative" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = {
  id: "kt_customer_view_payment_method",
  class: "card-body pt-0 px-5"
}
const _hoisted_74 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_75 = { class: "col-3" }
const _hoisted_76 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_77 = ["onClick", "href", "aria-controls"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3 rotate-90" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
        fill: "black"
      })
    ])
  ])
], -1))
const _hoisted_79 = { class: "me-3" }
const _hoisted_80 = { class: "d-flex align-items-center" }
const _hoisted_81 = { class: "text-gray-800 fs-5" }
const _hoisted_82 = { class: "col-3" }
const _hoisted_83 = { class: "form-check form-switch mt-2" }
const _hoisted_84 = ["disabled", "checked", "onClick"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, null, -1))
const _hoisted_86 = ["id", "data-bs-parent"]
const _hoisted_87 = { class: "w-100 py-5" }
const _hoisted_88 = { class: "table-responsive mt-3" }
const _hoisted_89 = { class: "table align-middle table-hover table-row-bordered fs-6 gy-3" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-35" }, "Permissions"),
    /*#__PURE__*/_createElementVNode("th", null, "Read"),
    /*#__PURE__*/_createElementVNode("th", null, "Create"),
    /*#__PURE__*/_createElementVNode("th", null, "Update"),
    /*#__PURE__*/_createElementVNode("th", null, "Delete")
  ])
], -1))
const _hoisted_91 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_92 = ["disabled", "id", "checked", "onClick"]
const _hoisted_93 = ["for"]
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_97 = ["disabled", "id", "checked", "onClick"]
const _hoisted_98 = ["for"]
const _hoisted_99 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_100 = ["disabled", "id", "checked", "onClick"]
const _hoisted_101 = ["for"]
const _hoisted_102 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_103 = ["disabled", "id", "checked", "onClick"]
const _hoisted_104 = ["for"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Are you sure to delete selected role(s)?", -1))
const _hoisted_107 = {
  key: 1,
  class: "flex-lg-row-fluid card h-auto bg-white"
}
const _hoisted_108 = { class: "text-center my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZFilter = _resolveComponent("VZFilter")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_VZModal = _resolveComponent("VZModal")!
  const _component_UserRoleModal = _resolveComponent("UserRoleModal")!
  const _component_UserRoleActivityModal = _resolveComponent("UserRoleActivityModal")!
  const _component_vz_role_clone_modal = _resolveComponent("vz-role-clone-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["post d-flex flex-column-fluid", [_ctx.loading && 'overlay overlay-block']]),
        id: "kt_post"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.searchRole) = $event)),
                          type: "text",
                          class: "form-control ps-13 mb-2 mb-sm-0",
                          name: "search",
                          placeholder: _ctx.t('common.search')
                        }, null, 8, _hoisted_11), [
                          [_vModelText, _ctx.formData.searchRole]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refreshList && _ctx.refreshList(...args)), ["stop"])),
                          type: "button",
                          class: "btn bg-transparent position-relative d-block pe-0"
                        }, _hoisted_14)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_VZFilter, {
                        ref: "VZFilter",
                        options: _ctx.tableFilter,
                        defaultFilter: {},
                        viewName: "roleFilters",
                        onFilterChange: _ctx.onFilterChange
                      }, {
                        actions: _withCtx(() => [
                          (_ctx.tableFilter && _ctx.tableFilter.length)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_16, [
                                _hoisted_17,
                                (_ctx.activeFilter)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.activeFilter), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["options", "onFilterChange"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          (_ctx.hasPermission('VYZOR:USERS:ROLES:DELETE'))
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "checkbox",
                                class: "form-check-input",
                                id: "inboxCheckAll",
                                "true-value": "false",
                                "false-value": "true",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAll())),
                                checked: 
                            _ctx.formData.selectedRoles.length > 0 &&
                            _ctx.unlockedRoles.length > 0 &&
                            _ctx.formData?.selectedRoles?.length ===
                              _ctx.unlockedRoles.length
                          ,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.allselected) = $event))
                              }, null, 8, _hoisted_23)), [
                                [_vModelCheckbox, _ctx.formData.allselected]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          (_ctx.hasPermission('VYZOR:USERS:ROLES:DELETE'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: _ctx.formData.selectedRoles.length < 1,
                                type: "button",
                                class: _normalizeClass(["btn btn-outline btn-outline-danger btn-active-light-danger me-5", {
                            'btn-outline-danger btn-active-light-danger':
                              _ctx.formData.selectedRoles.length > 0,
                          }]),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog = true))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fas fa-trash-alt", {
                              'text-danger': _ctx.formData.selectedRoles.length > 0,
                            }])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("common.delete")), 1)
                              ], 10, _hoisted_25))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        (
                          _ctx.formData.selectedRoles.length === 1 &&
                          _ctx.isRoleLocked(_ctx.formData.selectedRoles)
                            ? _ctx.hasPermission('VYZOR:USERS:ROLES:UPDATE')
                            : _ctx.hasPermission('VYZOR:USERS:ROLES:CREATE')
                        )
                          ? (_openBlock(), _createElementBlock("a", _hoisted_27, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas", 
                            _ctx.formData.selectedRoles.length === 1 &&
                            _ctx.isRoleLocked(_ctx.formData.selectedRoles)
                              ? 'fa-edit'
                              : 'fa-plus'
                          ])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(_ctx.formData.selectedRoles.length === 1 &&
                          _ctx.isRoleLocked(_ctx.formData.selectedRoles)
                            ? _ctx.t("pages.user.editRole")
                            : _ctx.t("pages.user.addRole")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_28,
                    _createVNode(_component_Form, {
                      "validation-schema": _ctx.roleValidation,
                      onSubmit: _ctx.createRole,
                      ref: "formRef"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            (
                            _ctx.formData.selectedRoles.length == 1 &&
                            _ctx.isRoleLocked(_ctx.formData.selectedRoles)
                          )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _hoisted_32,
                                  _createVNode(_component_Field, {
                                    class: "form-control",
                                    modelValue: _ctx.selectedRoleName,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedRoleName) = $event)),
                                    type: "text",
                                    name: "Roles",
                                    autocomplete: "off",
                                    id: "editRoleName"
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createVNode(_component_ErrorMessage, { name: "Roles" })
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createVNode(_component_Field, {
                                    class: "form-control",
                                    modelValue: _ctx.formData.RoleName,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.RoleName) = $event)),
                                    type: "text",
                                    name: "Role",
                                    autocomplete: "off",
                                    id: "roleName"
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(_component_ErrorMessage, { name: "Role" })
                                    ])
                                  ])
                                ])),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("button", {
                                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px buttonclose",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeForm())),
                                type: "button"
                              }, _toDisplayString(_ctx.t("common.close")), 1),
                              _createElementVNode("button", _hoisted_40, _toDisplayString(_ctx.t("common.save")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["validation-schema", "onSubmit"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _hoisted_41,
                        _createElementVNode("div", {
                          class: _normalizeClass(["d-flex flex-stack p-3 pointer-cursor", {
                        'bg-normal': role.value !== _ctx.selectedRole.value,
                        'bg-selected': role.value == _ctx.selectedRole.value,
                      }]),
                          onClick: ($event: any) => (_ctx.updateSelectedRole(role, $event))
                        }, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              (
                              _ctx.hasPermission('VYZOR:USERS:ROLES:UPDATE') ||
                              _ctx.hasPermission('VYZOR:USERS:ROLES:DELETE')
                            )
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "checkbox",
                                    value: `${role.value}`,
                                    disabled: role.lock,
                                    class: "form-check-input",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.selectedRoles) = $event)),
                                    onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, _hoisted_45)), [
                                    [_vModelCheckbox, _ctx.formData.selectedRoles]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("a", _hoisted_47, _toDisplayString(role && role.label ? role.label : ""), 1)
                            ])
                          ]),
                          _createElementVNode("div", {
                            onClick: _withModifiers(($event: any) => (_ctx.openUserModal(role)), ["stop"]),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_roleView",
                            class: "d-flex flex-column align-items-end ms-2 display-inline"
                          }, [
                            (role.lock)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, _hoisted_51))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_52, [
                              _hoisted_53,
                              _createTextVNode(" " + _toDisplayString(role.userCount), 1)
                            ]),
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (_ctx.resetWebId(role.value)), ["stop"]),
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3",
                              style: {"font-size":"6px"},
                              "aria-expanded": "false"
                            }, _hoisted_56, 8, _hoisted_54),
                            _createElementVNode("ul", {
                              class: _normalizeClass(["dropdown-menu dropdown-menu-end border role-clone", 'show-clone-' + role.value])
                            }, [
                              _createElementVNode("li", null, [
                                (_ctx.hasPermission('VYZOR:USERS:ROLES:CREATE'))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (_ctx.setRoleCloneData(role)), ["stop"]),
                                      class: "dropdown-item text-hover-primary",
                                      type: "button"
                                    }, _toDisplayString(_ctx.t("pages.user.clone.title")), 9, _hoisted_57))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2)
                          ], 8, _hoisted_48)
                        ], 10, _hoisted_42)
                      ], 64))
                    }), 128)),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", null, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("select", {
                            name: "kt_customers_table_length",
                            class: "form-select form-select-sm",
                            onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args))),
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rowsPerPage) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PAGE_ITEM, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item,
                                value: item
                              }, _toDisplayString(item), 9, _hoisted_59))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.rowsPerPage]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_pagination, {
                          "current-page": _ctx.page,
                          "onUpdate:current-page": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.page) = $event)),
                          onCurrentChange: _ctx.currentPageChange,
                          "page-size": +_ctx.rowsPerPage || 0,
                          layout: "prev, pager, next",
                          total: _ctx.total,
                          "hide-on-single-page": false,
                          background: ""
                        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.roles && _ctx.roles.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.selectedRole && _ctx.selectedRole.label
                          ? _ctx.selectedRole.label
                          : ""), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("span", {
                                class: "svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-3 translate-middle-y",
                                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.searchPermission && _ctx.searchPermission(...args)))
                              }, _hoisted_71),
                              _withDirectives(_createElementVNode("input", {
                                onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.searchPermission && _ctx.searchPermission(...args))),
                                type: "text",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.searchPermission) = $event)),
                                class: "form-control form-control ps-13 mb-2 mb-sm-0",
                                id: "searchForm",
                                placeholder: _ctx.t('common.search')
                              }, null, 40, _hoisted_72), [
                                [_vModelText, _ctx.formData.searchPermission]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionGroupsFilter, (perm, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["d-flex align-items-center collapsible rotate", {
                            collapsed: !_ctx.permissionGroupsCollpased[i],
                          }]),
                                  onClick: ($event: any) => (_ctx.toggleCollapse(i)),
                                  "data-bs-toggle": "collapse",
                                  href: `#kt_${i}`,
                                  role: "button",
                                  "aria-expanded": "false",
                                  "aria-controls": `kt_${perm.title}`
                                }, [
                                  _hoisted_78,
                                  _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("div", _hoisted_80, [
                                      _createElementVNode("div", _hoisted_81, _toDisplayString(perm.title), 1)
                                    ])
                                  ])
                                ], 10, _hoisted_77),
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("div", _hoisted_83, [
                                    (_openBlock(), _createElementBlock("input", {
                                      key: `toggle-${_ctx.selectedRole.value}-${i}-${_ctx.arrayModuleNameList[i]}`,
                                      disabled: 
                                !_ctx.hasPermission('VYZOR:USERS:ROLES:UPDATE') ||
                                !_ctx.hasPermission('VYZOR:USERS:ROLES:CREATE') ||
                                !_ctx.hasPermission('VYZOR:USERS:ROLES:READ') ||
                                !_ctx.hasPermission('VYZOR:USERS:ROLES:DELETE') ||
                                _ctx.loading
                              ,
                                      checked: _ctx.arrayModuleNameList[i],
                                      class: _normalizeClass([{
                                'form-input-unchecked': !_ctx.arrayModuleNameList[i],
                              }, "form-check-input"]),
                                      onClick: _withModifiers(($event: any) => (
                                _ctx.disableModule(
                                  perm.title,
                                  $event?.target?.checked
                                )
                              ), ["stop"]),
                                      type: "checkbox"
                                    }, null, 10, _hoisted_84)),
                                    _hoisted_85
                                  ])
                                ])
                              ])
                            ]),
                            (_openBlock(), _createElementBlock("div", {
                              id: `kt_${i}`,
                              class: _normalizeClass(["collapse fs-6 ps-5", {
                        show: _ctx.permissionGroupsCollpased[i],
                      }]),
                              "data-bs-parent": `#kt_${i}`,
                              key: `collapse-${i}-${_ctx.permissionGroupsCollpased[i]}`
                            }, [
                              _createElementVNode("div", _hoisted_87, [
                                _createElementVNode("div", _hoisted_88, [
                                  _createElementVNode("table", _hoisted_89, [
                                    _hoisted_90,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(perm.childPermissions, (childPerm, j) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: j }, [
                                          _createElementVNode("td", null, _toDisplayString(childPerm.title == "Sites"
                                        ? "Branches"
                                        : childPerm.title == "Sites Overview"
                                        ? "Branch Overview"
                                        : childPerm.title === "Sms"
                                        ? "Chat"
                                        : childPerm.title), 1),
                                          _createElementVNode("td", null, [
                                            (
                                        _ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'READ'
                                        ) != null
                                      )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                  (_openBlock(), _createElementBlock("input", {
                                                    key: `perm-${
                                          _ctx.selectedRole.value
                                        }-${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'READ'
                                        )}`,
                                                    disabled: 
                                          !_ctx.hasPermission(
                                            'VYZOR:USERS:ROLES:UPDATE'
                                          ) || _ctx.loading
                                        ,
                                                    type: "checkbox",
                                                    class: _normalizeClass(["form-check-input", {
                                          'form-input-unchecked':
                                            !_ctx.checkPermission(
                                              _ctx.getSpecificPermissionFromList(
                                                childPerm.permissions,
                                                'READ'
                                              )
                                            ),
                                        }]),
                                                    id: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'READ'
                                        )}`,
                                                    checked: 
                                          _ctx.checkPermission(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'READ'
                                            )
                                          )
                                        ,
                                                    onClick: ($event: any) => (
                                          _ctx.updatePermissionForRole(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'READ'
                                            ),
                                            this.checked,
                                            true,
                                            perm.title
                                          )
                                        )
                                                  }, null, 10, _hoisted_92)),
                                                  _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'READ'
                                        )}`
                                                  }, null, 8, _hoisted_93)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (childPerm.title === 'Clients')
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_94))
                                            : (_openBlock(), _createElementBlock("td", _hoisted_95, [
                                                (
                                        _ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'CREATE'
                                        ) != null
                                      )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                      _createElementVNode("input", {
                                                        disabled: 
                                          !_ctx.hasPermission(
                                            'VYZOR:USERS:ROLES:UPDATE'
                                          ) || _ctx.loading
                                        ,
                                                        type: "checkbox",
                                                        class: _normalizeClass(["form-check-input", {
                                          'form-input-unchecked':
                                            !_ctx.checkPermission(
                                              _ctx.getSpecificPermissionFromList(
                                                childPerm.permissions,
                                                'CREATE'
                                              )
                                            ),
                                        }]),
                                                        id: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'CREATE'
                                        )}`,
                                                        checked: 
                                          _ctx.checkPermission(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'CREATE'
                                            )
                                          )
                                        ,
                                                        onClick: ($event: any) => (
                                          _ctx.updatePermissionForRole(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'CREATE'
                                            ),
                                            this.checked,
                                            true,
                                            perm.title
                                          )
                                        )
                                                      }, null, 10, _hoisted_97),
                                                      _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'CREATE'
                                        )}`
                                                      }, null, 8, _hoisted_98)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])),
                                          _createElementVNode("td", null, [
                                            (
                                        _ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'UPDATE'
                                        ) != null
                                      )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                                  _createElementVNode("input", {
                                                    disabled: 
                                          !_ctx.hasPermission(
                                            'VYZOR:USERS:ROLES:UPDATE'
                                          ) || _ctx.loading
                                        ,
                                                    type: "checkbox",
                                                    class: _normalizeClass(["form-check-input", {
                                          'form-input-unchecked':
                                            !_ctx.checkPermission(
                                              _ctx.getSpecificPermissionFromList(
                                                childPerm.permissions,
                                                'UPDATE'
                                              )
                                            ),
                                        }]),
                                                    id: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'UPDATE'
                                        )}`,
                                                    checked: 
                                          _ctx.checkPermission(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'UPDATE'
                                            )
                                          )
                                        ,
                                                    onClick: ($event: any) => (
                                          _ctx.updatePermissionForRole(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'UPDATE'
                                            ),
                                            this.checked,
                                            true,
                                            perm.title
                                          )
                                        )
                                                  }, null, 10, _hoisted_100),
                                                  _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'UPDATE'
                                        )}`
                                                  }, null, 8, _hoisted_101)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("td", null, [
                                            (
                                        _ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'DELETE'
                                        ) != null
                                      )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                  _createElementVNode("input", {
                                                    disabled: 
                                          !_ctx.hasPermission(
                                            'VYZOR:USERS:ROLES:UPDATE'
                                          ) || _ctx.loading
                                        ,
                                                    type: "checkbox",
                                                    class: _normalizeClass(["form-check-input", {
                                          'form-input-unchecked':
                                            !_ctx.checkPermission(
                                              _ctx.getSpecificPermissionFromList(
                                                childPerm.permissions,
                                                'DELETE'
                                              )
                                            ),
                                        }]),
                                                    id: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'DELETE'
                                        )}`,
                                                    checked: 
                                          _ctx.checkPermission(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'DELETE'
                                            )
                                          )
                                        ,
                                                    onClick: ($event: any) => (
                                          _ctx.updatePermissionForRole(
                                            _ctx.getSpecificPermissionFromList(
                                              childPerm.permissions,
                                              'DELETE'
                                            ),
                                            this.checked,
                                            true,
                                            perm.title
                                          )
                                        )
                                                  }, null, 10, _hoisted_103),
                                                  _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: `formSwitch_${_ctx.getSpecificPermissionFromList(
                                          childPerm.permissions,
                                          'DELETE'
                                        )}`
                                                  }, null, 8, _hoisted_104)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ], 10, _hoisted_86))
                          ]),
                          _hoisted_105
                        ], 64))
                      }), 128)),
                      _createVNode(_component_VZModal, {
                        id: `vz_modal_bulk_delete_role`,
                        title: `${_ctx.t('common.confirmDelete')}`,
                        widthClass: 'width-650',
                        showDialog: _ctx.showDialog,
                        onModalClose: _cache[18] || (_cache[18] = 
                    () => {
                      _ctx.showDialog = false;
                    }
                  )
                      }, {
                        actions: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showDialog = false))
                          }, _toDisplayString(_ctx.t("common.close")), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px",
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedRoles && _ctx.deleteSelectedRoles(...args)))
                          }, _toDisplayString(_ctx.t("common.delete")), 1)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_106
                        ]),
                        _: 1
                      }, 8, ["title", "showDialog"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.t("common.noDataFound")), 1)
                ]))
          ])
        ])
      ], 2)
    ]),
    _createVNode(_component_UserRoleModal, {
      data: _ctx.selectedRoleData,
      showDialog: _ctx.openUserNameModal,
      onCloseUserModal: _cache[19] || (_cache[19] = ($event: any) => (_ctx.openUserNameModal = false))
    }, null, 8, ["data", "showDialog"]),
    _createVNode(_component_UserRoleActivityModal, {
      refresh: _ctx.loading,
      icon: "bi bi-person-check fs-3",
      viewName: "Roles Activity Pulse",
      type: "1200,1900,2200"
    }, null, 8, ["refresh"]),
    (_ctx.openCloneModal)
      ? (_openBlock(), _createBlock(_component_vz_role_clone_modal, {
          key: 0,
          role: _ctx.roleObj,
          onCloneSubmit: _ctx.submitClone,
          onOnCancel: _cache[20] || (_cache[20] = ($event: any) => (_ctx.openCloneModal = false))
        }, null, 8, ["role", "onCloneSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}